const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

const getCountryName = (iso2: string): string => {
  return regionNames.of(iso2.toUpperCase()) || 'Unknown country code';
};

export default getCountryName;
